export enum CreditCardType {
    Amex = 1,
    Mastercard = 2,
    Discover = 3,
    Visa = 4
}
